<template>
    <div>
        <div class="fptplay_title-box container">
            <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="margin-right: 20px"
            >
                <circle cx="18" cy="18" r="15" fill="white" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 18.0087C3 9.72938 9.73263 3 18 3C26.2674 3 33 9.72938 33 18.0087C33 26.2706 26.2674 33 18 33C9.73263 33 3 26.2706 3 18.0087ZM23.5019 19.5268C23.6612 19.3676 23.8639 19.1216 23.9073 19.0637C24.139 18.7598 24.2548 18.3835 24.2548 18.0087C24.2548 17.5876 24.1245 17.1968 23.8784 16.8784C23.8582 16.8583 23.8187 16.8153 23.7672 16.7593C23.6709 16.6544 23.5327 16.504 23.4006 16.3719C22.2133 15.0984 19.1149 13.0145 17.4932 12.3777C17.2471 12.2779 16.6245 12.0593 16.2915 12.0449C15.973 12.0449 15.6689 12.1172 15.3793 12.2619C15.0174 12.4645 14.7278 12.7829 14.5685 13.1592C14.4672 13.4197 14.3079 14.2012 14.3079 14.2156C14.1486 15.0695 14.0618 16.4588 14.0618 17.9928C14.0618 19.4559 14.1486 20.7858 14.279 21.6541C14.2825 21.6577 14.295 21.7198 14.3143 21.8163C14.3732 22.1096 14.4957 22.7206 14.6264 22.9711C14.945 23.5789 15.5676 23.9551 16.2336 23.9551H16.2915C16.7259 23.9407 17.638 23.5644 17.638 23.5499C19.1728 22.9132 22.1988 20.9305 23.4151 19.6136L23.5019 19.5268Z"
                    fill="url(#paint0_linear_823_6802)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_823_6802"
                        x1="18"
                        y1="3"
                        x2="18"
                        y2="33.0002"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#F15701" />
                        <stop offset="1" stop-color="#F4B301" />
                    </linearGradient>
                </defs>
            </svg>
            <p class="fptplay_p" :style="{ color: textColor }">{{ message }}</p>
        </div>
        <section-box class="section-tabs">
            <template #header>
                <!-- select box -->
                <div class="row">
                    <div class="col-12">
                        <div class="list-btn d-flex flex-row align-items-center over-auto">
                            <h2 v-if="title" class="text-bold camera-seo fix-tabs-mob" v-text="title"></h2>
                            <!-- nav tab menu -->
                            <ul class="nav nav-tabs ml-lg-0 no-wrap">
                                <li
                                    style="cursor: pointer"
                                    class="nav-item"
                                    @click="changeTab(tab)"
                                    v-for="(tab, tabIndex) in tabs"
                                    :key="`section-${idSection}-${tabIndex}-${tab.CmsContent.system_name}`"
                                >
                                    <h2
                                        style="margin: 0 2px"
                                        class="fptplay-text__font-weight-700"
                                        href="javascript:;"
                                        :class="[
                                            'tab-seo kv-fplay-tab',
                                            { active_fplay: tab.CmsContent.system_name == value },
                                        ]"
                                        :id="tab.CmsContent.system_name"
                                        v-text="tab.CmsContent.short_name"
                                    ></h2>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- info box -->
                <div class="row pt-3">
                    <div class="col-12">
                        <div class="tab-content" id="myTabContent">
                            <div class="active show tab-pane fade">
                                <slot :name="value"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <!-- calculator box -->
                <div class="row gutter-24">
                    <div class="col-12">
                        <div class="calculator-box d-flex flex-rows flex-md-row pb-3">
                            <div class="d-flex col-6 flex-column justify-content-center">
                                <div class="d-flex flex-column">
                                    <div class="fptplay-price__color-orange">
                                        <span v-if="currentTab.RealMonth > 0" class="text-bold text-20"
                                            ><format-number
                                                class="price text-bold"
                                                :number="currentTab.RealPromotionMonth"
                                        /></span>
                                        <span v-if="currentTab.RealPromotionMonth > 0" class="text-12">{{currentTab.CmsContent.unit}}</span>
                                    </div>
                                    <div
                                        class="clo-black76"
                                        v-if="
                                            PromotionPrice == true &&
                                            currentTab.RealPromotionMonth !== currentTab.RealMonth
                                        "
                                    >
                                        <span v-if="currentTab.RealMonth > 0" class="text-med text-12">
                                            <del
                                                ><format-number
                                                    class="price text-bold"
                                                    :number="currentTab.RealMonth"
                                                />{{currentTab.CmsContent.unit}}</del
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- calculator total, buy now -->
                            <div
                                v-if="!commingSoon"
                                class="ml-md-auto mt-3 mt-md-0 justify-content-center kd-fplay-btn-full"
                            >
                                <a
                                    href="javascript:;"
                                    style="align"
                                    class="btn btn-custom btn-buy orange text-center fptplay-text__font-weight-700"
                                    @click="onSubmit"
                                >
                                    <div v-show="loading">
                                        <span class="spinner-border spinner-border-sm" role="status"></span>
                                        Loading...
                                    </div>
                                    <div v-show="!loading">{{ 'Mua ngay' }}</div>
                                </a>
                            </div>
                            <div v-else class="ml-md-auto mt-3 mt-md-0 kd-fplay-btn-full">
                                <a class="btn btn-custom btn-buy orange text-center" href="javascript:;">
                                    <div v-show="loading">
                                        <div class="spinner-border spinner-border-sm" role="status" />
                                        Loading...
                                    </div>
                                    <div v-show="!loading">
                                        <span class="fptplay-text__font-weight-700">Chưa mở bán</span>
                                        <span class="totalPrice"></span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </section-box>
    </div>
</template>
<script>
import SectionBox from './SectionBox.vue';
import FormatNumber from './FormatNumber.vue';
import isMobile from '@/mycore/utils/mobile-detect';
import { PROMOTION } from '../../configs/constants';
export default {
    components: {
        SectionBox,
        FormatNumber,
    },
    props: {
        message: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: 'white',
        },
        idSection: {
            type: String,
            default: 'fpt-play',
        },
        title: {
            type: String,
            default: '',
        },
        tabs: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        title: 'Gói VIP',
                        images: [
                            {
                                src: 'https://picsum.photos/534/324?random=1',
                                alt: 'Image Alt Demo',
                            },
                        ],
                        detail: [],
                        packages: [],
                    },
                ];
            },
        },
        value: {
            type: String,
        },
        onChange: {
            type: Function,
            require: false,
            default: () => {},
        },
        loading: {
            type: Boolean,
        },
        optionQuantity: {
            type: Object,
        },
        label: {
            type: Object,
            default: {
                buyNow: 'Mua ngay',
            },
        },
    },
    data: function () {
        return {
            currentTab: {},
            PromotionPrice: PROMOTION.PROMOTIONPRICE,
            PromotionTag: PROMOTION.PROMOTIONTAG,
        };
    },

    mounted() {
        let cTab = this.tabs.find((tab) => tab.CmsContent.system_name == this.value);
        if (cTab) {
            this.$store.dispatch('fptplay/updateLangdingPageBanner', cTab.banner);
            this.currentTab = cTab;
        }
    },
    watch: {
        loading() {
            let cTab = this.tabs.find((tab) => tab.CmsContent.system_name == this.value);
            if (cTab) {
                this.$store.dispatch('fptplay/updateLangdingPageBanner', cTab.banner);
                this.currentTab = cTab;
            }
        },
        value: function (value) {
            this.currentTab = this.tabs.find((tab) => tab.CmsContent.system_name == value) ?? this.tabs[0];
            this.$store.dispatch('fptplay/updateLangdingPageBanner', this.currentTab.banner);
        },
    },
    computed: {
        commingSoon() {
            const item = this.currentTab;
            return !item || item.length === 0 || item.RealPromotionMonth == 0;
        },
        checkMobile() {
            return isMobile();
        },
    },
    methods: {
        changeTab(tab) {
            this.$store.dispatch('fptplay/updateLangdingPageBanner', tab.banner);
            this.$router.replace({ path: `/fpt-play/${tab.CmsContent.route_name}` }).catch(() => {});
            if (tab.CmsContent.system_name !== this.value) {
                this.currentTab = { ...tab };
                this.onChange();
                this.$emit('input', tab.CmsContent.system_name);
                tab.Qty = this.optionQuantity.minValue & 1;
            }
            this.$emit('get-meta', tab.CmsContent.service_code);
        },
        onSubmit() {
            this.$emit('onProgress');
        },
    },
};
</script>
<style lang="scss" scoped>
.fptplay-text__font-weight-700 {
    font-weight: 700 !important ;
}
.fptplay-price__color-orange {
    color: #ff8840 !important;
}
.section-tabs {
    .price-box {
        > div:not(:last-child) {
            margin-bottom: 20px;
        }
    }
    .btn-buy {
        display: block !important;
    }
}
.kd-fplay-btn-full {
    width: 50%;
}
.kv-fplay-tab {
    padding-right: 15px !important;
    padding-left: 15px !important;
    color: #000;
    margin-right: 10 !important;
    border-bottom: 1px solid #fff !important;
}
.active_fplay {
    background: #ff8840 !important;
    -webkit-background: #ff8840 !important;
    border-radius: 4px 4px 0px 0px !important;
    color: #fff !important;
    border-bottom: 1px solid #ff8840 !important;
}
.fptplay_p {
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 34px;
}
.fptplay_title-box {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}
@media (max-width: 668px) {
    .kd-fplay-btn-full {
        width: 100%;
    }
    .kv-fplay-tab {
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .fix-tabs-mob {
        margin-right: 5px !important;
    }
}
@media (max-width: 375px) {
    .kv-fplay-tab {
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .fix-tabs-mob {
        margin-right: 1px !important;
    }
}
</style>
